import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { LIBRARY_URL } from "@/config/api";
import { useOrgSidebar } from "../../contexts/OrgSidebarContext";
import IframeScreen from "../IframeScreen/IframeScreen";

const OrganizationScreen = () => {
  const { targetId, targetLibraryId } = useOrgSidebar();
  const location = useLocation();
  const [url, setUrl] = useState<string>("");

  useEffect(() => {
    setUrl(`${LIBRARY_URL}${getCallbackUrl()}`);
  }, [location.pathname, targetId, targetLibraryId]);

  const getCallbackUrl = () => {
    return `/taga-library/cloud/${targetId}/${targetLibraryId}`;
  };

  return <IframeScreen url={url} />;
};

export default OrganizationScreen;
